import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';
import { pickBy, every, merge } from 'lodash';
let SearchTable = class SearchTable extends Vue {
    constructor() {
        super(...arguments);
        this.filterSelections = {};
        this.search = '';
        this.tabTitle = '';
    }
    created() {
        const session = this.$session;
        const tableQueries = session.get('sw5eTableQueries') || {};
        if (!tableQueries[this.name])
            session.set('sw5eTableQueries', { ...tableQueries, [this.name]: {} });
        this.search = this.initialSearch || (this.storedQuery ? this.storedQuery.Search : '');
        this.filterSelections = this.storedQuery || {};
        this.tabTitle = this.tableType;
    }
    get storedQuery() {
        return this.$session.get('sw5eTableQueries')[this.name];
    }
    get title() {
        const titleString = this.tabTitle + Vue.prototype.$titleSuffix;
        return (this.search ? this.search + ' | ' + titleString : titleString);
    }
    get alignedHeaders() {
        return this.headers.map(header => ({
            render: (value) => value,
            ...header,
            align: 'center'
        }));
    }
    get validFilterSelections() {
        return pickBy(this.filterSelections, (filterSelection) => Array.isArray(filterSelection) ? filterSelection.length > 0 : filterSelection);
    }
    get filteredItems() {
        return this.items.filter(item => every(this.validFilterSelections, (selection, filterField) => {
            const filterHeader = this.headers.find(({ text }) => text === filterField);
            return filterHeader ? filterHeader.filterFunction(item, selection) : true;
        }));
    }
    get headersWithFilters() {
        return this.headers.filter(({ filterFunction }) => filterFunction);
    }
    handleFilterChange(field, input) {
        const session = this.$session;
        const tableQueries = session.get('sw5eTableQueries');
        session.set('sw5eTableQueries', merge(tableQueries, { [this.name]: { [field]: input } }));
    }
};
__decorate([
    Prop(Array)
], SearchTable.prototype, "items", void 0);
__decorate([
    Prop(Array)
], SearchTable.prototype, "headers", void 0);
__decorate([
    Prop(Function)
], SearchTable.prototype, "customSort", void 0);
__decorate([
    Prop(String)
], SearchTable.prototype, "initialSearch", void 0);
__decorate([
    Prop(String)
], SearchTable.prototype, "tableType", void 0);
__decorate([
    Prop(String)
], SearchTable.prototype, "name", void 0);
SearchTable = __decorate([
    Component({
        components: {
            Loading
        }
    })
], SearchTable);
export default SearchTable;
